'use strict';

/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/
/*global services*/
function WinsWindow() {

    this.init();
}

WinsWindow.prototype = $.extend({}, {
    construtor: 'WinsWindow',

    //**************************************************************************
    //**************************************************************************

    reload: function reload() {
        var _this = this;

        if (services.has('inpage-controller')) {
            services.get('inpage-controller').reloadContent();
        } else {
            location.reload();
        }

        return _this;
    },

    redirectTo: function redirectTo(href) {
        var _this = this;

        if (services.has('inpage-controller')) {
            services.get('inpage-controller').loadContent(href);
        } else {
            location.href = href;
        }

        return _this;
    },

    //**************************************************************************
    init: function init() {
        var _this = this;

        $.ajaxSetup({
            global: true,
            error: function (xhr, status, err) {
                if (xhr.status === 403) {
                    _this.redirectTo($('body').data('login_url'));
                }
            }
        });

        return _this;
    }
});
